var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"padding":"30px","text-align":"center"}},[_vm._v("\n  请点击右上角，并选择在浏览器中打开。\n")])}
var staticRenderFns = []

export { render, staticRenderFns }